import { createCartState } from './cart-state.model';
import { CartStateQuery } from './cart-state.query';
import { SessionStorageType } from '../../services/tracking/session-storage';
import * as i0 from "@angular/core";
import * as i1 from "./cart-state.store";
export class CartStateService {
    constructor(cartStateStore) {
        this.cartStateStore = cartStateStore;
        this.cartStateQuery = new CartStateQuery(this.cartStateStore);
        this._state = createCartState({});
        const storage = sessionStorage.getItem(SessionStorageType.CART);
        if (storage === undefined || storage === null) {
            const cart = createCartState({});
            this._state = cart;
        }
        else {
            this._state = JSON.parse(storage);
        }
    }
    set cartState(cartState) {
        this.cartStateStore.set([cartState]);
        sessionStorage.setItem(SessionStorageType.CART, JSON.stringify(cartState));
    }
    get cartState() {
        if (this.cartStateQuery.getCount() === 1) {
            const cart = this.cartStateQuery.getAll()[0];
            return createCartState({
                cart: cart.cart,
                cartId: cart.cartId,
                cartResponse: cart.cartResponse
            });
        }
        else {
            const ls = JSON.parse(sessionStorage.getItem(SessionStorageType.CART));
            if (ls === undefined) {
                return null;
            }
            else {
                return ls;
            }
        }
    }
    set _state(state) {
        this.cartStateStore.set([state]);
    }
    get _state() {
        if (this.cartStateQuery.getCount() === 1) {
            const state = this.cartStateQuery.getAll()[0];
            return createCartState({
                cartId: state.cartId,
                cart: state.cart,
                cartResponse: state.cartResponse
            });
        }
        else {
            return null;
        }
    }
    set cartId(cartId) {
        const state = this._state;
        state.cartId = cartId;
        this._state = state;
    }
    get cartId() {
        return this._state.cartId;
    }
    set cart(cart) {
        const state = this._state;
        state.cart = cart;
        this._state = state;
    }
    get cart() {
        return this._state.cart;
    }
    set cartResponse(cartResponse) {
        const state = this._state;
        state.cartResponse = cartResponse;
        this._state = state;
    }
    get cartResponse() {
        return this._state.cartResponse;
    }
}
CartStateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CartStateService_Factory() { return new CartStateService(i0.ɵɵinject(i1.CartStateStore)); }, token: CartStateService, providedIn: "root" });
